module.exports = __webpack_public_path__ + "img/a3-افقی.6c2d19e9.jpg";